import React from 'react';

export function humanJoin(arr?: string[] | React.ReactNode[], lastSymbol?: string, symbol?: string) {
	if (!arr) return null;
	arr = arr.filter(Boolean);
	if (arr.length === 0) return null;
	else if (arr.length === 1) return arr[0];
	else
		return (
			<>
				{arr.slice(0, arr.length - 1).map((item, index) => (
					<React.Fragment key={index}>
						{item}
						{index !== arr!.length - 2 && <>{symbol || ', '}</>}
					</React.Fragment>
				))}
				{lastSymbol ? lastSymbol : ' и'} {arr[arr.length - 1]}
			</>
		);
}
